"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanEmail = exports.capitalizeFirstLetter = void 0;
const capitalizeFirstLetter = (phrase) => {
    if (!phrase)
        return "";
    return phrase
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
};
exports.capitalizeFirstLetter = capitalizeFirstLetter;
const cleanEmail = (email) => {
    // Convert email to lowercase
    email = email.toLowerCase().trim();
    // Check if the email contains "@gmail.com" or "@googlemail.com"
    if (email.includes("@gmail.com") || email.includes("@googlemail.com")) {
        // Remove any characters between '+' and '@', and remove '.' before '@'
        email = email.replace(/\.(?=[^@]*@)/g, '').replace(/\+.+?(?=@)/g, '');
    }
    // Remove whitespace from email
    email = email.replace(/\s/g, '');
    return email;
};
exports.cleanEmail = cleanEmail;
